// import React, { Fragment } from 'react';
// import { Link } from 'react-router-dom'
// import PageTitle from '../../components/pagetitle/PageTitle'
// import Scrollbar from '../../components/scrollbar/scrollbar'
//
// import CtaSection from '../../components/CtaSection/CtaSection';
// import srImg from '../../images/services/ServicesPage/IT_Solutions_Banner.png'
// import ServiceSection from '../../components/ServiceSection/ServiceSection';
// import WhyUs from '../AboutUsPage/WhyUs';
//
//
// const ServicePage = (props) => {
//
//     const ClickHandler = () => {
//         window.scrollTo(10, 0);
//     }
//     return (
//         <Fragment>
//             <main className="page_content about-page">
//                 <PageTitle pageTitle={'Our Services'} pagesub={'Services 😍'} pageTop={'Our Main'} />
//                 <section className="about_section section_space bg-light">
//                     <div className="container">
//                         <div className="row align-items-center justify-content-lg-between">
//                             <div className="col-lg-5 order-lg-last">
//                                 <div className="team_cartoon_image">
//                                     <img src={srImg} alt="Service Cartoon"/>
//                                 </div>
//                             </div>
//                             <div className="col-lg-5">
//                                 <div className="about_content">
//                                     <div className="heading_block">
//                                         <div className="heading_focus_text">
//                                             We Are
//                                             <span className="badge bg-secondary text-white">IT Guidance 🙂</span>
//                                         </div>
//                                         <h2 className="heading_text">
//                                             Tailored IT Solutions for Your Success
//                                         </h2>
//                                         <p className="heading_description mb-0">
//                                             we understand that every business is unique, with its own set of challenges, goals, and aspirations. That's why we offer tailored IT solutions designed.
//                                         </p>
//                                     </div>
//                                     <Link onClick={ClickHandler} to={'/service'} className="btn">
//                                         <span className="btn_label" data-text="Talk to an Expart">Talk to an Expart</span>
//                                         <span className="btn_icon">
//                                             <i className="fa-solid fa-arrow-up-right"></i>
//                                         </span>
//                                     </Link>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//                 <ServiceSection />
//                 <div className="pt-130"></div>
//                 <WhyUs />
//             </main>
//             <CtaSection />
//             <Scrollbar />
//         </Fragment>
//     )
// };
// export default ServicePage;




import React, { Fragment } from 'react';

import { Link } from 'react-router-dom';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import CtaSection from '../../components/CtaSection/CtaSection';
import srImg from '../../images/services/ServicesPage/IT_Solutions_Banner.png';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import WhyUs from '../AboutUsPage/WhyUs';
import './ServicePage.css'

const ServicePage = () => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <Fragment>
            <main className="page_content about-page">
                {/* Page Title */}
                <PageTitle
                    pageTitle={'Our Services'}
                    pagesub={''}
                    pageTop={''}
                />

                {/* About Section */}
                <section className="about_section py-5 bg-light">
                    <div className="container">
                        <div className="row justify-content-center g-4  h-100">

                            {/* Image Column */}
                            <div className="col-12 col-md-6 col-lg-5 order-lg-last text-center d-flex align-items-start h-100">
                                <div className="team_cartoon_image w-100">
                                    <img
                                        src={srImg}
                                        alt="Service Cartoon"
                                        className="img-fluid"
                                        style={{ maxHeight: '400px', objectFit: 'contain', width: '100%' }}
                                    />
                                </div>
                            </div>

                            {/* Content Column */}
                            <div className="col-12 col-md-6 col-lg-5 d-flex align-items-start h-100">
                                <div className="about_content text-center text-md-start w-100">
                                    <h2 className="display-6 fw-bold mb-3">
                                        Tailored IT Solutions for Your Success
                                    </h2>
                                    <p className="mb-4 text-muted ms-15px" >
                                    We offer customized IT solutions to address your unique challenges and help achieve business goals. Our team designs strategies that optimize operations, improve efficiency, and enhance customer experiences. By leveraging technology, we ensure your systems grow with your business and stay competitive. Let us help you navigate the digital landscape for long-term success.
                                    </p>
                                    <Link
                                        onClick={ClickHandler}
                                        to={'/contact'}
                                        className="btn btn-outline-primary d-inline-flex align-items-center gap-2 px-4 py-2 shadow-sm"
                                    >
                                        <span className="btn_label">Talk to an Expert</span>
                                        <i className="fa-solid fa-arrow-up-right"></i>
                                    </Link>
                                </div>
                            </div>


                        </div>
                    </div>
                </section>

                {/* Service Section */}
                <ServiceSection />

                {/* Why Us Section with spacing */}
                <div className="pt-5"></div>
                <WhyUs />
            </main>

            {/* CTA & Scrollbar */}
            <CtaSection />
            <Scrollbar />
        </Fragment>
    )
};

export default ServicePage;
